import { Flex } from "@acko-tech/building-blocks.ui.common";
import styled from "styled-components";
import { Text } from "@acko-tech/building-blocks.ui.typography";

export const CheckoutCardWrapper = styled.div`
  background: linear-gradient(104deg, rgba(251, 246, 255, 0.50) 0.49%, rgba(238, 234, 255, 0.50) 99%);
  display: flex;
  border: 1px solid #E0E0E8;
  border-radius: 12px;
  padding-right: 10px;
`;

export const CarDetailsContainer = styled(Flex)`
  align-items: center;
  gap: 12px;
  padding: 16px;
`;

export const ContainerText = styled(Text)`
  font-size: 12px;
  font-weight: 400;
  color: #36354C;
  span{
    font-size: 14px;
    font-weight: 600;
  }
`;